<template>
  <div
    v-if="$feature.enableLanguagePreference && $languagePref?.browserLanguage === 'es' && hasSpanishPage"
    class="f-col <md:mb-4 <md:space-y-4 md:flex-row md:justify-right"
  >
    <p class="text-xs font-bold flex center md:mr-4 md:w-1/2">
      {{ translations.description }}
    </p>
    <vf-button class="<md:w-full" size="xs" @click="$languagePref?.set(language, 'CTA')">
      {{ translations.cta }}
    </vf-button>
  </div>
</template>

<script lang="ts" setup>
import $st from '#server-assets-brand/i18n/texts/es-us.json'

const { $t } = useNuxtApp()
const route = useRoute()
const language = ref()
const translations = ref()
const hasSpanishPage = ref(false)

watch(() => route.path, () => {
  language.value = route.path.includes('-es') ? 'EN' : 'ES'
  translations.value = language.value === 'EN' ? $t.languageSwitcher : $st.languageSwitcher

  const translationsAvalilable = ['gift-card', 'help', 'order-status', 'xplr-pass', 'help-es', 'xplr-pass-es', 'gift-card-es', 'order-status-es']
  const excludedPages = ['privacy']
  hasSpanishPage.value = route.path.split('/').some((page) => translationsAvalilable.includes(page))
    && !route.path.split('/').find((page) => excludedPages.includes(page))
}, { immediate: true })
</script>
